module.exports = __webpack_public_path__ + "static/media/Mcarousel1bg.c974660f.png";